module.exports = __webpack_public_path__ + "img/47.cdb4e815.jpg";